export default "/images/logo-shipro-light.svg?4f2dbf19f0278236fcf0dfae85eeb6b5";